import { Box, Button, Typography } from "@mui/material";

const BookingPolicies = () => {
  return (
    <Box sx={{ mt: "20px" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography
          sx={{
            fontSize: "24px",
            fontWeight: 600,
            lineHeight: "26px",
            color: "#323232",
          }}
        >
          Policies:
        </Typography>
        <Button
          variant="contained"
          color="error"
          size="small"
          sx={{ borderRadius: "10px" }}
          // componen="a"
          href="mailto:help@haystackers.com"
        >
          Need Help?
        </Button>
      </Box>

      <Box>
        <Typography
          sx={{
            color: "#323232",
            fontWeight: 400,
            fontSize: "16px",
            lineHeight: "24px",

            mt: "15px",
            mb: "20px",
          }}
        >
          Cancellation policy - Flexible, If cancelled
        </Typography>{" "}
        <Typography
          sx={{
            color: "#323232",
            fontWeight: 400,
            fontSize: "16px",
            lineHeight: "24px",
            mb: "10px",
          }}
        >
          • Any insurance paid is refunded.
        </Typography>
        <Typography
          sx={{
            color: "#323232",
            fontWeight: 400,
            fontSize: "16px",
            lineHeight: "24px",
          }}
        >
          • Renter is responsible for 25% of the booking total, plus the service
          fee.
        </Typography>
      </Box>
    </Box>
  );
};

export default BookingPolicies;
